'use client';

var translations = {
    'You get maximum _s attached CVs': 'Bạn đã tải lên tối đa _s CVs',
    Cancel: 'Huỷ bỏ',
    'Select your existing CV': 'Chọn CV đã tải lên trước đó của bạn',
    Searchable: 'Cho phép tìm kiếm',
    Replace: 'Thay thế',
    'Updated:': 'Cập nhật lúc:',
    'You have got the maximum of _s attached CV on VietnamWorks. ': 'Bạn đã đạt đến số lượng tải lên tối đa _s CV trên VietnamWorks.',
    'Choose one of existed CV to replace:': 'Chọn một CV trước đó để thay thế',
    'The replaced attached CV will automatically marks as "Searchable".': 'CV được thay thế sẽ tự động đánh dấu là "Cho phép tìm kiếm"',
    'You can': 'Bạn có thể',
    'switch the searchable CVs in Profile settings': 'chuyển trạng thái tìm kiếm CV trong Cài đặt hồ sơ',
    'Please select a CV to replace': 'Vui lòng chọn một CV để thay thế',
    'my-profile': 'ho-so',
    'Note: The CV replacement': 'Chú ý: Việc thay thế hồ sơ sẽ',
    'will not change the CV sent to employers.': 'không làm thay đổi hồ sơ đã gửi cho nhà tuyển dụng.'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
